import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type MenuItem = { label: string; url: string };

export const useCmsMenu = (location: "header" | "footer") => {
  return useQuery({
    queryKey: ["cms-menu", location],
    queryFn: async () => {
      const { data } = await supabase.from("menus").select("items").eq("location", location).maybeSingle();
      const items = (data?.items as any) || [];
      return Array.isArray(items) ? (items as MenuItem[]).filter((i) => i?.label && i?.url) : [];
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useSiteSetting = <T = any>(key: string) => {
  return useQuery({
    queryKey: ["site-setting", key],
    queryFn: async () => {
      const { data } = await supabase.from("site_settings").select("value").eq("key", key).maybeSingle();
      return (data?.value as T) || null;
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useDbProducts = (platformSlug?: string) => {
  return useQuery({
    queryKey: ["db-products", platformSlug],
    queryFn: async () => {
      const platformQuery = supabase.from("platforms").select("id, slug").eq("is_active", true);
      const { data: platforms } = await platformQuery;
      const platform = platforms?.find((p) => p.slug === platformSlug);
      if (!platform) return [];
      const { data } = await supabase
        .from("products")
        .select("*")
        .eq("platform_id", platform.id)
        .eq("is_active", true)
        .order("sort_order");
      return data || [];
    },
    enabled: !!platformSlug,
    staleTime: 2 * 60 * 1000,
  });
};
